import { useInterstateTheme } from '../../InterstateThemeProvider';
import { Box } from '../../Box';
import { isValidElement } from 'react';
import { CardMedia } from '../../Card';
import { jsx as _jsx } from "react/jsx-runtime";
const resolveStyle = theme => ({
  display: 'flex',
  padding: '8px 12px 8px 20px',
  justifyContent: 'flex-end',
  alignItems: 'center',
  alignSelf: 'stretch',
  minWidth: '72px',
  maxWidth: '72px',
  width: '72px',
  height: '63px',
  minHeight: '63px',
  maxHeight: '63px'
});
const resolveSlotStyle = theme => ({
  display: 'flex',
  width: '40px',
  minWidth: '40px',
  maxWidth: '40px',
  height: '40px',
  minHeight: '40px',
  maxHeight: '40px',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center'
});
const resolveImage = image => {
  if (/*#__PURE__*/isValidElement(image)) {
    return image;
  } else if (typeof image === 'string') {
    return /*#__PURE__*/_jsx(CardMedia, {
      image: image,
      maxHeight: '40px',
      maxWidth: '40px',
      height: '40px',
      width: '40px'
    });
  } else {
    return null;
  }
};

/**
 * Represents a container for a toast icon or an image.
 *
 * @param {ToastImageProps} props - The props for the toast icon container.
 * @returns {JSX.Element} - The JSX element representing the toast image container.
 */
export const ToastImageContainer = props => {
  const theme = useInterstateTheme();
  const style = resolveStyle(theme);
  const slotStyle = resolveSlotStyle(theme);
  const {
    image
  } = props;
  return /*#__PURE__*/_jsx(Box, {
    className: 'ids-toast-icon-container',
    sx: style,
    children: /*#__PURE__*/_jsx(Box, {
      className: 'ids-toast-icon-slot',
      sx: slotStyle,
      children: resolveImage(image)
    })
  });
};